const colors = {
  background: {
    main: '#F9F9F9',
  },
  lightBackground: {
    main: '#EFB6B6',
  },
  primary: {
    main: '#CD1719',
  },
  secondary: {
    main: '#CD1719',
  },
  error: {
    main: '#D22127',
  },
  success: {
    main: '#028E59',
  },
  text: {
    primary: '#333333',
    secondary: '#FFF',
  },
  warning: {
    main: '#F9B41E',
  },
  input: {
    background: '#FFF',
    label: '#333333',
    border: '#333333',
  },
  alternative: {
    contrast: '#EFEFEF',
  },
  stepper: {
    icon: '#FFF',
    line: '#FFF',
    text: '#FFF',
  },
};

export default colors;
